import experienceModel from "models/experience.model";
import { IoIosAddCircle } from "react-icons/io";
import { useEffect, useState } from "react";
import { IoCloseSharp } from "react-icons/io5";
import { useParams, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { helper } from "lib/helper";
import AddButton from "components/Button/AddButton";
import BackButton from "components/Button/BackButton";

const EditExperience = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [experience, setExperience] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [activities, setActivities] = useState("");
  const [goodsOrServices, setGoodsOrServices] = useState("");
  const [intendedAudience, setIntendedAudience] = useState("");
  const [placeVibes, setPlaceVibes] = useState("");
  const [activityVibe, setActivityVibe] = useState("");
  const [buddyVibe, setBuddyVibe] = useState("");
  const [enhanceEntry, setEnhanceEntry] = useState("");
  const [gifts, setGifts] = useState("");
  const [enhanceExit, setEnhanceExit] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  // Generic function to update any list in the experience object
  const updateList = (listName, action, value = "", indexToRemove = null) => {
    setExperience((prevExperience) => {
      const updatedList = [...(prevExperience[listName] || [])];
      if (action === "add" && value) {
        updatedList.push(value);
      } else if (action === "remove" && indexToRemove !== null) {
        updatedList.splice(indexToRemove, 1);
      }
      return { ...prevExperience, [listName]: updatedList };
    });
  };

  const formatTime = (time) => {
    const [hours, minutes] = time.split(":");
    const formattedHours = hours.padStart(2, "0"); // Ensure two digits for hours
    return `${formattedHours}:${minutes}`;
  };

  // Function to fetch experience details
  const getExperienceDetails = async () => {
    try {
      const foundExperience = await experienceModel.experienceDetails(id);
      if (foundExperience) {
        const formattedExperience = {
          ...foundExperience?.data?.data[0],
        };
        setStartTime(
          formatTime(formattedExperience.experienceTime.split("-")[0].trim())
        );
        setEndTime(
          formatTime(formattedExperience.experienceTime.split("-")[1].trim())
        );

        setExperience(formattedExperience);
      } else {
        setExperience(null);
      }
      setIsLoading(false);
    } catch (error) {
      setExperience(null);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getExperienceDetails();
  }, [id]);

  console.log({startTime , endTime})

  const handleSubmit = (e) => {
    e.preventDefault();
    if (id) {
      try {
        experienceModel.editExperienceDetails({...experience , experienceTime : `${startTime}-${endTime}`}, id).then((result) => {
          if (result) {
            helper.sweetalert.toast("Experience updated", "success");
            navigate(-1); // Navigate after successful update
          }
        });
      } catch (error) {
        helper.sweetalert.toast(
          error.response?.data?.message || "Update failed",
          "warning"
        );
      }
    } else {
      helper.sweetalert.toast("Please fill all fields", "warning");
    }
  };

  useEffect(() => {
    getExperienceDetails();
  }, [id]);

  if (isLoading) {
    return <div>Loading...</div>; // Loader while fetching data
  }

  return (
    <Container className="pt-7">
      <Card className="shadow">
        <CardHeader>
          <h1>Edit Experience</h1>
        </CardHeader>
        <CardBody>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label for="activities">Activities</Label>
              <Input
                type="text"
                name="activities"
                id="activities"
                value={activities}
                onChange={(e) => setActivities(e.target.value)}
                placeholder="Add Activities"
              />
              <button
                type="button"
                className="btn btn-success mt-2"
                onClick={() => {
                  updateList("coreActivities", "add", activities);
                  setActivities("");
                }}
              >
                Add
              </button>
              <div className="mt-2">
                {experience?.coreActivities?.map((item, index) => (
                  <span
                    className="badge rounded-pill text-bg-success"
                    key={index}
                  >
                    {item}{" "}
                    <IoCloseSharp
                      size={15}
                      onClick={() =>
                        updateList("coreActivities", "remove", "", index)
                      }
                    />
                  </span>
                ))}
              </div>
            </FormGroup>
            <FormGroup>
              <Label for="goodsOrServices">Goods and Services</Label>
              <Input
                type="text"
                name="goodsOrServices"
                id="goodsOrServices"
                value={goodsOrServices}
                onChange={(e) => setGoodsOrServices(e.target.value)}
                placeholder="Add Goods and Services"
              />
              <button
                type="button"
                className="btn btn-success mt-2"
                onClick={() => {
                  updateList("goodsOrServices", "add", goodsOrServices);
                  setGoodsOrServices("");
                }}
              >
                Add
              </button>
              <div className="mt-2">
                {experience?.goodsOrServices?.map((item, index) => (
                  <span
                    className="badge rounded-pill text-bg-success"
                    key={index}
                  >
                    {item}{" "}
                    <IoCloseSharp
                      size={15}
                      onClick={() =>
                        updateList("goodsOrServices", "remove", "", index)
                      }
                    />
                  </span>
                ))}
              </div>
            </FormGroup>
            <FormGroup>
              <Label for="intendedAudience">Intended Audience</Label>
              <Input
                type="text"
                name="intendedAudience"
                id="intendedAudience"
                value={intendedAudience}
                onChange={(e) => setIntendedAudience(e.target.value)}
                placeholder="Add Intended Audience"
              />
              <button
                type="button"
                className="btn btn-success mt-2"
                onClick={() => {
                  updateList("intendedAudience", "add", intendedAudience);
                  setIntendedAudience("");
                }}
              >
                Add
              </button>
              <div className="mt-2">
                {experience?.intendedAudience?.map((item, index) => (
                  <span
                    className="badge rounded-pill text-bg-success"
                    key={index}
                  >
                    {item}{" "}
                    <IoCloseSharp
                      size={15}
                      onClick={() =>
                        updateList("intendedAudience", "remove", "", index)
                      }
                    />
                  </span>
                ))}
              </div>
            </FormGroup>
            <FormGroup>
              <Label for="maxGroupSize">Group Size</Label>
              <Input
                type="number"
                name="maxGroupSize"
                id="maxGroupSize"
                min={0}
                onChange={(e) =>
                  setExperience((prev) => ({
                    ...prev,
                    maxGroupSize: e.target.value,
                  }))
                }
                defaultValue={experience?.maxGroupSize}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="location">Arrival Spot Location</Label>
              <Input
                type="text"
                name="location"
                id="location"
                value={experience?.location}
                onChange={(e) =>
                  setExperience((prev) => ({
                    ...prev,
                    location: e.target.value,
                  }))
                }
                required
              />
            </FormGroup>
            {/* <FormGroup>
              <Label for="location">Experience Spot Location</Label>
              <Input
                type="text"
                name="location"
                id="location"
                value={experience?.location}
                onChange={(e) => setExperience(prev => ({...prev, location: e.target.value}))}
                required
              />
            </FormGroup> */}
            <FormGroup>
              <Label for="experienceTime">Experience Time</Label>
              <div className="d-flex gap-3">
                <div>
                  <Label for="startTime">Start Time</Label>
                  <Input
                    type="time"
                    name="startTime"
                    id="startTime"
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                  />
                </div>
                <div>
                  <Label for="endTime">End Time</Label>
                  <Input
                    type="time"
                    name="endTime"
                    id="endTime"
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                  />
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <Label for="placeVibes">Place Vibes</Label>
              <Input
                type="text"
                name="placeVibes"
                id="placeVibes"
                value={placeVibes}
                onChange={(e) => setPlaceVibes(e.target.value)}
                placeholder="Add Place Vibes"
              />
              <button
                type="button"
                className="btn btn-success mt-2"
                onClick={() => {
                  updateList("placeVibes", "add", placeVibes);
                  setPlaceVibes("");
                }}
              >
                Add
              </button>
              <div className="mt-2">
                {experience?.placeVibes?.map((item, index) => (
                  <span
                    className="badge rounded-pill text-bg-success"
                    key={index}
                  >
                    {item}{" "}
                    <IoCloseSharp
                      size={15}
                      onClick={() =>
                        updateList("placeVibes", "remove", "", index)
                      }
                    />
                  </span>
                ))}
              </div>
            </FormGroup>
            <FormGroup>
              <Label for="activities">Activities Vibe</Label>
              <Input
                type="text"
                name="activityVibe"
                id="activityVibe"
                value={activityVibe}
                onChange={(e) => setActivityVibe(e.target.value)}
                placeholder="Add Activities Vibe"
              />
              <button
                type="button"
                className="btn btn-success mt-2"
                onClick={() => {
                  updateList("activityVibe", "add", activityVibe);
                  setActivityVibe("");
                }}
              >
                Add
              </button>
              <div className="mt-2">
                {experience?.activityVibe?.map((item, index) => (
                  <span
                    className="badge rounded-pill text-bg-success"
                    key={index}
                  >
                    {item}{" "}
                    <IoCloseSharp
                      size={15}
                      onClick={() =>
                        updateList("activityVibe", "remove", "", index)
                      }
                    />
                  </span>
                ))}
              </div>
            </FormGroup>
            <FormGroup>
              <Label for="buddyVibe">Buddy Vibes</Label>
              <Input
                type="text"
                name="buddyVibe"
                id="buddyVibe"
                value={buddyVibe}
                onChange={(e) => setBuddyVibe(e.target.value)}
                placeholder="Add Buddy Vibes"
              />
              <button
                type="button"
                className="btn btn-success mt-2"
                onClick={() => {
                  updateList("buddyVibe", "add", buddyVibe);
                  setBuddyVibe("");
                }}
              >
                Add
              </button>
              <div className="mt-2">
                {experience?.buddyVibe?.map((item, index) => (
                  <span
                    className="badge rounded-pill text-bg-success"
                    key={index}
                  >
                    {item}{" "}
                    <IoCloseSharp
                      size={15}
                      onClick={() =>
                        updateList("buddyVibe", "remove", "", index)
                      }
                    />
                  </span>
                ))}
              </div>
            </FormGroup>
            <FormGroup>
              <Label for="enhanceEntry">Entry Elements</Label>
              <Input
                type="text"
                name="enhanceEntry"
                id="enhanceEntry"
                value={enhanceEntry}
                onChange={(e) => setEnhanceEntry(e.target.value)}
                placeholder="Add Entry Element"
              />
              <button
                type="button"
                className="btn btn-success mt-2"
                onClick={() => {
                  updateList("enhanceEntry", "add", enhanceEntry);
                  setEnhanceEntry("");
                }}
              >
                Add
              </button>
              <div className="mt-2">
                {experience?.enhanceEntry?.map((item, index) => (
                  <span
                    className="badge rounded-pill text-bg-success"
                    key={index}
                  >
                    {item}{" "}
                    <IoCloseSharp
                      size={15}
                      onClick={() =>
                        updateList("enhanceEntry", "remove", "", index)
                      }
                    />
                  </span>
                ))}
              </div>
            </FormGroup>
            <FormGroup>
              <Label for="gifts">Surprise Gift</Label>
              <Input
                type="text"
                name="gifts"
                id="gifts"
                value={gifts}
                onChange={(e) => setGifts(e.target.value)}
                placeholder="Add Surprise Gift"
              />
              <button
                type="button"
                className="btn btn-success mt-2"
                onClick={() => {
                  updateList("gifts", "add", gifts);
                  setGifts("");
                }}
              >
                Add
              </button>
              <div className="mt-2">
                {experience?.gifts?.map((item, index) => (
                  <span
                    className="badge rounded-pill text-bg-success"
                    key={index}
                  >
                    {item}{" "}
                    <IoCloseSharp
                      size={15}
                      onClick={() => updateList("gifts", "remove", "", index)}
                    />
                  </span>
                ))}
              </div>
            </FormGroup>
            <FormGroup>
              <Label for="enhanceExit">Exit Elements</Label>
              <Input
                type="text"
                name="enhanceExit"
                id="enhanceExit"
                value={enhanceExit}
                onChange={(e) => setEnhanceExit(e.target.value)}
                placeholder="Add Exit Elements"
              />
              <button
                type="button"
                className="btn btn-success mt-2"
                onClick={() => {
                  updateList("enhanceExit", "add", enhanceExit);
                  setEnhanceExit("");
                }}
              >
                Add
              </button>
              <div className="mt-2">
                {experience?.enhanceExit?.map((item, index) => (
                  <span
                    className="badge rounded-pill text-bg-success"
                    key={index}
                  >
                    {item}{" "}
                    <IoCloseSharp
                      size={15}
                      onClick={() =>
                        updateList("enhanceExit", "remove", "", index)
                      }
                    />
                  </span>
                ))}
              </div>
            </FormGroup>
            <FormGroup>
              <Label for="price">Price Per Person</Label>
              <Input
                type="number"
                name="price"
                id="price"
                min={0}
                value={experience?.price}
                onChange={(e) =>
                  setExperience((prev) => ({ ...prev, price: Number(e.target.value) }))
                }
                required
              />
            </FormGroup>
            <div className="d-flex justify-content-between align-items-center">
              <BackButton />
              <AddButton title='Save Changes' />
             </div>
            {/* <Button color="primary" type="submit">
              Save Changes
            </Button> */}
          </Form>
        </CardBody>
      </Card>
    </Container>
  );
};

export default EditExperience;
